import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as RoutePath,
} from "react-router-dom";
import LoginPage from "./pages/auth/LoginPage";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import OrderManagement from "./pages/home/orderManagement/OrderManagement";
import DriverManagement from "./pages/home/driverManagement/DriverManagement";
import OrderDetails from "./pages/home/orderManagement/OrderDetails";
import PrivateRoutes from "./utils/PrivateRoute";
import { useSelector } from "react-redux";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import Traking from "./pages/home/orderManagement/Tracking";

const Routes = () => {
  const { token } = useSelector((state) => state.auth);

  return (
    <RoutePath>
      {/* redirect to /ordermanage when site open on / */}
      <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/termsConditions" element={<TermsConditions />} />
      {!token && <Route path="/login" element={<LoginPage />} />}
      <Route element={<PrivateRoutes token />}>
        <Route path="/ordermanage" element={<OrderManagement />} />
        <Route path="/ordermanage/:id" element={<OrderDetails />} />

        <Route path="/driver" element={<DriverManagement />} />
      </Route>
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/resetpassword/:token" element={<ResetPassword />} />
      <Route path="/tracking/:id" element={<Traking />} />
      <Route
        path="*"
        element={<Navigate to={token ? "/ordermanage" : "/login"} />}
      />
    </RoutePath>
  );
};

export default Routes;
